'use strict';

import Vue from 'vue'
import Vuex from 'vuex'
import VueContentPlaceholders from 'vue-content-placeholders'
import { authLogout } from './models/auth'
import { getProfile, getParentProfile } from './models/profile'
import axios from "axios"
import app from './main'
import { convertSecondToText, toCommas, getRoleType } from "./utils/utils";

// https://momentjscom.readthedocs.io/en/latest/moment/06-i18n/01-changing-locale/
moment.locale('vi', {
    months: 'Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12'.split('_'),
    monthsShort: 'Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12'.split('_'),
    weekdaysShort: 'Chủ nhật_Thứ 2_Thứ 3_Thứ 4_Thứ 5_Thứ 6_Thứ 7'.split('_'),
    relativeTime: {
        future: 'Trong %s',
        past: 'Cách đây %s',
        s: 'vài giây',
        m: '1 phút',
        mm: '%d phút',
        h: '1 giờ',
        hh: '%d giờ',
        d: '1 ngày',
        dd: '%d ngày',
        M: '1 tháng',
        MM: '%d tháng',
        y: '1 năm',
        yy: '%d năm'
    },
});

Vue.use(Vuex);
Vue.use(VueContentPlaceholders);

Vue.filter('toCurrency', function(value, currency) {
    const num = new Intl.NumberFormat('us-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    }).format(parseFloat(value));

    return num.replace('US$', '').replace('$', '') + '$';
});

Vue.filter('formatDate', function(value, format = 'HH:mm DD/MM/YYYY') {
    if (value) {
        return moment(String(value)).format(format)
    }
});

Vue.filter('convertUnitToTime', function(time, format = 'DD MMM, YYYY HH:mm:ss') {
    if (time) {
        const lang = localStorage.getItem('lang') || 'vi';

        return moment.unix(time).locale(lang).format(format)
    }

    return '';
});

Vue.filter('convertUnitToTime_1', function(time, format = 'DD MMM, YYYY - HH:mm:ss') {
    if (time) {
        const lang = localStorage.getItem('lang') || 'vi';

        return moment.unix(time).locale(lang).format(format)
    }

    return '';
});

Vue.filter('convertSecondToCountdown', function(time) {
    if (time) {
        const current_time = Math.floor(Date.now() / 1000);
        const countdown = time - current_time;

        console.log(countdown, time, current_time)

        if (countdown <= 0) {
            return "00:00:00";
        }

        return convertSecondToText(countdown)
    }

    return '';
});

Vue.filter('toCommas', function(value) {
    if (value) {
        return toCommas(value)
    }

    return '0';
});

//axios.defaults.withCredentials = true;

axios.interceptors.response.use(function(response) {
    // Do something with response data
    // console.log(response);

    if (response.data.success == false &&
        response.data.error.code == 1200 &&
        window.location.pathname != '/login') {
        console.log('Auth require from store 48')

        window.location.href = "/login"
    }

    return response;
}, function(error) {
    // Do something with response error
    console.log(error);

    return Promise.reject(error);
});

export const store = new Vuex.Store({
    state: {
        //layout: 'app-layout',
        layout: 'loading-layout',
        locale: 'en',
        is_login: localStorage.getItem('is_login') || false,
        user_info: {
            name: 'Guest',
            profile: {
                fullname: ''
            },
            menus: [],
            balances: [],
        },
        gem_icon_url: '/themes/ito/images/icon-gem.svg',
        treasure_icon_url: '/themes/ito/images/gem-chest.svg',
        is_claim: false,
        configs: JSON.parse(localStorage.getItem('configs')),
        alert: {
            is_show: false,
            type: 'error',
            message: ''
        },
        is_loading: false,
        menu_active: 'home',
        role_type: 'student',
        hide_popup: false,
        is_lasted: false,
        first_login: false,
        live_classes: [],
        filter_class: '',
        showEffect: true,
    },

    mutations: {
        SET_LAYOUT(state, payload) {
            state.layout = payload
        },

        SET_ROLE_TYPE(state, payload) {
            state.role_type = payload;
            localStorage.setItem('role_type', payload);
        },

        SET_CHECK_POPUP(state, payload) {
            state.hide_popup = payload;
            localStorage.setItem('hide_popup', payload);
        },

        SET_FIRST_LOGIN(state, payload) {
            state.first_login = payload;
            localStorage.setItem('first_login', payload);
        },

        SET_USER_INFO(state, payload) {
            state.user_info = payload;
            // localStorage.setItem('grade', payload.grade);
        },

        SET_GEM_ICON_URL(state, payload) {
            state.gem_icon_url = payload
        },

        SET_TREASURE_URL(state, payload) {
            state.treasure_icon_url = payload
        },

        SET_LANG(state, locale) {
            state.locale = locale
            app.$i18n.locale = locale
        },

        setAlert(state, alert) {
            state.alert = alert;
        },

        setLoading(state, isLoading) {
            state.is_loading = isLoading;
        },

        setConfigs(state, configs) {
            state.configs = configs;
        },

        setClaim(state, is_claim) {
            state.is_claim = is_claim;
        },

        setLasted(state, is_lasted){
            state.is_lasted = is_lasted;
        },

        setEventPopup(state, event_popup){
            state.event_popup = event_popup;
        },

        setMenuActive(state, menu) {
            console.log(menu)

            state.menu_active = menu;
        },

        setFilterClass(state, filter) {
            state.filter_class = filter;
        },

        setAuth(state, isLogin) {
            state.is_login = isLogin;

            localStorage.setItem('is_login', isLogin);
            localStorage.removeItem("child_account");
        },

        logout(state) {
            state.user_info = {
                name: 'Guest'
            };
            state.is_login = false;

            localStorage.removeItem('is_login');
            localStorage.removeItem("grade");
            localStorage.removeItem("role_type");
            localStorage.removeItem("child_account");
            localStorage.removeItem("access_token");
            localStorage.removeItem("banner_hidden");
        },

        setLiveClasses(state, live_classes) {
            state.live_classes = live_classes;
        },

        setShowEffect(state, showEffect) {
            state.showEffect = showEffect;
        },
    },

    actions: {
        SET_USER_INFO: async({ commit }) => {
            if (window.location.pathname != '/login') {
                if (getRoleType() == 'parent') {
                    await axios.all([
                        getParentProfile({
                            notification_id: window.localStorage.getItem('firebaseToken'),
                            type_code: 'web'
                        })
                    ]).then(axios.spread(({ data }) => {
                        commit("setLoading", false);

                        commit("SET_LAYOUT", 'parent-layout');

                        if (data.code != 0) {
                            localStorage.removeItem('is_login');
                            localStorage.removeItem('grade');
                            localStorage.removeItem("child_account");
                            console.log('Auth require from store 147')

                            window.location.href = "/login";

                            return;
                        }

                        const user_info = data.results;

                        user_info.avatar_url = user_info.avatar_url || '/themes/web/assets/images/avatar-default-2.svg';

                        const contest = user_info?.contest_info;

                        if (contest?.id) {
                            const now = moment(); // thời điểm hiện tại
                            const start = moment.parseZone(contest.start_time, moment.ISO_8601, true);
                            const end = moment.parseZone(contest.end_time, moment.ISO_8601, true);

                            if (start.isValid() && end.isValid() && now.isBetween(start, end, undefined, '[]')) {
                                commit("SET_GEM_ICON_URL", contest.gem_icon_url);
                                commit("SET_TREASURE_URL", contest.treasure_icon_url);
                            }
                        }

                        commit("SET_USER_INFO", user_info);
                    })).catch(error => {
                        console.log(error)

                        //commit("SET_LAYOUT", 'app-layout');
                        commit('logout');

                        console.log('Auth require from store 162')

                        //window.location.href = "/login"
                    });
                } else {
                    await axios.all([
                        getProfile({
                            notification_id: window.localStorage.getItem('firebaseToken'),
                            type_code: 'web'
                        })
                    ]).then(axios.spread(({ data }) => {
                        commit("setLoading", false);
                        commit("SET_LAYOUT", 'app-layout');

                        if (data.code != 0) {
                            localStorage.removeItem('is_login');
                            localStorage.removeItem('grade');
                            localStorage.removeItem("child_account");
                            console.log('Auth require from store 147')

                            window.location.href = "/login";

                            return;
                        }

                        const user_info = data.results;

                        user_info.avatar_url = user_info.avatar_url || '/themes/web/assets/images/avatar-default-2.svg';

                        const contest = user_info?.contest_info;

                        if (contest?.id) {
                            const now = moment();
                            const start = moment.parseZone(contest.start_time, moment.ISO_8601, true);
                            const end = moment.parseZone(contest.end_time, moment.ISO_8601, true);

                            if (start.isValid() && end.isValid() && now.isBetween(start, end, undefined, '[]')) {
                                commit("SET_GEM_ICON_URL", contest.gem_icon_url);
                                commit("SET_TREASURE_URL", contest.treasure_icon_url);
                            }
                        }

                        commit("SET_USER_INFO", user_info);
                    })).catch(error => {
                        console.log(error)

                        //commit("SET_LAYOUT", 'app-layout');
                        commit('logout');

                        console.log('Auth require from store 162')

                        //window.location.href = "/login"
                    });
                }
            }
        },

        setLiveClasses({ commit }, live_classes) {
            commit('setLiveClasses', live_classes);
        },

        SET_ROLE_TYPE({ commit }, role_type) {
            commit('SET_ROLE_TYPE', role_type);
        },

        SET_CHECK_POPUP({ commit }, hide_popup) {
            commit('SET_CHECK_POPUP', hide_popup);
        },

        SET_FIRST_LOGIN({ commit }, first_login) {
            commit('SET_CHECK_POPUP', first_login);
        },

        setLang({ commit }, locale) {
            commit('SET_LANG', locale)
        },

        setAlert({ commit }, alert) {
            commit('setAlert', alert);
        },

        setLoading({ commit }, isLoading) {
            commit('setLoading', isLoading);
        },

        setConfigs({ commit }, configs) {
            commit('setConfigs', configs);
        },

        setClaim({ commit }, is_claim) {
            commit('setClaim', is_claim);
        },

        setLasted({ commit }, is_lasted) {
            commit('setLasted', is_lasted);
        },

        setEventPopup({ commit }, event_popup) {
            commit('setEventPopup', event_popup);
        },

        setMenuActive({ commit }, menu) {
            commit('setMenuActive', menu);
        },

        setFilterClass({ commit }, filter) {
            commit('setFilterClass', filter);
        },

        setAuth({ commit }, isAuth) {
            commit('setAuth', isAuth);
        },

        logout({ commit }) {
            authLogout().then(({ data }) => {
                commit('logout');

                localStorage.removeItem('is_login');
                localStorage.removeItem('grade');
                localStorage.removeItem("child_account");
            });
        },
        setShowEffect({ commit }, showEffect) {
            commit('setShowEffect', showEffect);
        },
    },

    getters: {
        isLoggedIn(state) {
            return state.is_login;
        },

        layout(state) {
            return state.layout
        },

        isLoading(state) {
            return state.is_loading
        },

        menuActive(state) {
            return state.menu_active
        },

        alert(state) {
            return state.alert
        },

        user_info(state) {
            return state.user_info
        },

        role_type(state) {
            return state.role_type
        },

        configs(state) {
            return state.configs
        },

        live_classes(state) {
            return state.live_classes
        },

        filter_class(state) {
            return state.filter_class
        },
        showEffect(state) {
            return state.showEffect
        }
    }
});